// import { Options } from "~/components/LanguageSelector"
import Image from 'next/image';
import { ReactNode } from 'react';
import { Options, Languages } from '~/components/LanguageSelector';

export const languages: Options[] = [
  {
    id: '1',
    name: 'pt',
    target: (
      <Image width={30} height={20} alt="pt-br" src="/Images/pt_BR.svg" />
    ),
  },
  {
    id: '2',
    name: 'en',
    target: (
      <Image width={30} height={20} alt="en-us" src="/Images/en_US.svg" />
    ),
  },
  {
    id: '3',
    name: 'es',
    target: <Image width={30} height={20} alt="esp" src="/Images/es.svg" />,
  },
];

export const getFlag = (langName: Languages): ReactNode => {
  const language = languages.find(lang => lang.name === langName);
  return language?.target;
};

type Thead = {
  name: string;
  style: string;
};

export const tableHead: Thead[] = [
  { name: 'ID', style: 'border-b border-neutra3-cinzaquente10 text-left pl-1' },
  { name: 'Nome', style: 'border-b border-neutra3-cinzaquente10 text-left' },
  {
    name: 'Data',
    style: 'border-b border-neutra3-cinzaquente10 text-center',
  },
  { name: 'Email', style: 'border-b border-neutra3-cinzaquente10 text-left' },
  {
    name: 'Status',
    style: 'border-b border-neutra3-cinzaquente10 text-center',
  },
  {
    name: 'Ações',
    style: 'border-b border-neutra3-cinzaquente10 text-center',
  },
  {
    name: 'Idioma',
    style: 'border-b border-neutra3-cinzaquente10 text-center',
  },
];
